/**
 * @generated SignedSource<<b0186c75e5e687a5d57d44e17fb79447>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type ClientStatusStanding = "ACTIVE" | "INACTIVE" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "OPPORTUNITIES" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type CompanyViewOpportunities_Query$variables = {
  clientId?: string | null;
  loadSingleCurrency: boolean;
  loadMultiCurrency: boolean;
  loadCustomFields: boolean;
};
export type CompanyViewOpportunities_Query$data = {
  readonly viewer: {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly language: LANGUAGE | null;
    readonly company: {
      readonly id: string;
      readonly currency: string | null;
      readonly skillLevelsEnabled: boolean | null;
      readonly opportunityStageBands: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly startPercentage: number | null;
            readonly endPercentage: number | null;
            readonly winProbability: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly opportunityListCustomFieldDefinitions?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly key: string;
            readonly displayName: string;
            readonly type: string;
            readonly readOnly?: boolean;
            readonly options?: ReadonlyArray<{
              readonly id: string;
              readonly displayName: string;
            }>;
          } | null;
        } | null> | null;
      } | null;
      readonly client: {
        readonly id: string;
        readonly name: string;
        readonly logoId: string | null;
        readonly status: {
          readonly label: string;
          readonly standing: ClientStatusStanding;
        } | null;
      } | null;
    } | null;
    readonly filters: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly value: string | null;
          readonly section: FILTER_SECTION | null;
          readonly updatedAt: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly customProjectId: string | null;
          readonly name: string | null;
          readonly budgetType: BUDGET_TYPE | null;
          readonly stage: {
            readonly id: string;
            readonly name: string | null;
            readonly profile: PROJECT_STATUS | null;
          } | null;
          readonly description: string | null;
          readonly statusColor: string | null;
          readonly companyProjectId: number | null;
          readonly readOnlyAccess: boolean | null;
          readonly budget: number | null;
          readonly budgetBaseCurrency: number | null;
          readonly projectColor: string | null;
          readonly estimationUnit: string | null;
          readonly minutesPerEstimationPoint: number | null;
          readonly projectStartDay: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartYear: number | null;
          readonly projectEndDay: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndYear: number | null;
          readonly baselineWinChance: number | null;
          readonly sprintTimeBox: boolean | null;
          readonly currentProjectStatus: {
            readonly id: string;
            readonly color: string | null;
            readonly person: {
              readonly id: string;
              readonly firstName: string | null;
              readonly lastName: string | null;
            } | null;
          } | null;
          readonly client: {
            readonly id: string;
            readonly name: string;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
          } | null;
          readonly rateCard: {
            readonly id: string;
            readonly name: string | null;
            readonly currency: string | null;
            readonly parentRateCardId: string | null;
          } | null;
          readonly progress: number | null;
          readonly manualProgressOnProjectEnabled: boolean | null;
          readonly manualProgressOnPhasesEnabled: boolean | null;
          readonly manualProgressOnTasksEnabled: boolean | null;
          readonly priorityLevel: {
            readonly id: string;
            readonly name: string | null;
            readonly weight: number | null;
          } | null;
          readonly projectLabels: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly label: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly color: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly projectPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly isContactPerson: boolean | null;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly initials: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly wasOpportunity: boolean | null;
          readonly useBaseline: boolean | null;
          readonly baselineTarget: number | null;
          readonly quote: {
            readonly id: string;
            readonly status: string | null;
            readonly expiryDate: string | null;
          } | null;
          readonly clientContact: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly email: string | null;
          } | null;
          readonly salesperson: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly initials: string | null;
            readonly profilePictureId: string | null;
          } | null;
          readonly opportunityListCustomFields?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly key: string;
                readonly value: string | null;
              } | null;
            } | null> | null;
          } | null;
          readonly financialNumbers?: {
            readonly baselineRevenue: number | null;
            readonly billablePlannedTimeAndExpenses: number | null;
            readonly actualRevenue: number | null;
            readonly remainingRevenue: number | null;
            readonly forecastRevenue: number | null;
            readonly recognitionOpenRevenue: number | null;
            readonly recognitionForecastRevenue: number | null;
            readonly recognitionLockedRevenue: number | null;
            readonly plannedCost: number | null;
            readonly actualCost: number | null;
            readonly forecastCost: number | null;
            readonly remainingCost: number | null;
            readonly plannedProfit: number | null;
            readonly forecastProfit: number | null;
            readonly invoiced: number | null;
            readonly paid: number | null;
          } | null;
          readonly financialNumbersProjectCurrency?: {
            readonly baselineRevenue: number | null;
            readonly billablePlannedTimeAndExpenses: number | null;
            readonly actualRevenue: number | null;
            readonly remainingRevenue: number | null;
            readonly forecastRevenue: number | null;
            readonly recognitionOpenRevenue: number | null;
            readonly recognitionForecastRevenue: number | null;
            readonly recognitionLockedRevenue: number | null;
            readonly plannedCost: number | null;
            readonly actualCost: number | null;
            readonly forecastCost: number | null;
            readonly remainingCost: number | null;
            readonly plannedProfit: number | null;
            readonly forecastProfit: number | null;
            readonly invoiced: number | null;
            readonly paid: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type CompanyViewOpportunities_Query = {
  variables: CompanyViewOpportunities_Query$variables;
  response: CompanyViewOpportunities_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadCustomFields"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadMultiCurrency"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadSingleCurrency"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skillLevelsEnabled",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    (v9/*: any*/)
  ],
  "concreteType": "OpportunityStageBandTypeConnection",
  "kind": "LinkedField",
  "name": "opportunityStageBands",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OpportunityStageBandTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OpportunityStageBand",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "winProbability",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "opportunityStageBands(first:1000)"
},
v12 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "list",
    "value": "OPPORTUNITY_LIST"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v17 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "TextCustomField",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "IntegerCustomField",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "DecimalCustomField",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "DateCustomField",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomFieldDropdownOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "DropdownCustomField",
  "abstractKey": null
},
v22 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "clientId"
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "standing",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FilterTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Filter",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v10/*: any*/),
          (v26/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "section",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          (v27/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v29 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v30 = [
  {
    "kind": "Literal",
    "name": "excludeRestricted",
    "value": true
  },
  (v29/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profile",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetBaseCurrency",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectStatus",
  "kind": "LinkedField",
  "name": "currentProjectStatus",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v51/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v52/*: any*/),
        (v53/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v10/*: any*/),
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoDefaultId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v10/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityLevel",
  "kind": "LinkedField",
  "name": "priorityLevel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10000
    }
  ],
  "concreteType": "ProjectLabelTypeConnection",
  "kind": "LinkedField",
  "name": "projectLabels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectLabelTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectLabel",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "label",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v10/*: any*/),
                (v51/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectLabels(first:10000)"
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "contactsOnly",
      "value": true
    },
    (v29/*: any*/)
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContactPerson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v52/*: any*/),
                (v53/*: any*/),
                (v63/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                (v64/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wasOpportunity",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBaseline",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTarget",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Quote",
  "kind": "LinkedField",
  "name": "quote",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiryDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientContact",
  "kind": "LinkedField",
  "name": "clientContact",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "salesperson",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/),
    (v64/*: any*/),
    (v63/*: any*/)
  ],
  "storageKey": null
},
v72 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "baselineRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billablePlannedTimeAndExpenses",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invoiced",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paid",
    "storageKey": null
  }
],
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": (v72/*: any*/),
  "storageKey": null
},
v74 = {
  "condition": "loadMultiCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v73/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbersProjectCurrency",
      "plural": false,
      "selections": (v72/*: any*/),
      "storageKey": null
    }
  ]
},
v75 = {
  "condition": "loadSingleCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v73/*: any*/)
  ]
},
v76 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "OPPORTUNITIES"
  },
  (v29/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyViewOpportunities_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              {
                "condition": "loadCustomFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "opportunityListCustomFieldDefinitions",
                    "args": (v12/*: any*/),
                    "concreteType": "CustomFieldDefinitionV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFieldDefinitionsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDefinitionV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "customFieldDefinitionsV2(first:1000,list:\"OPPORTUNITY_LIST\")"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "filters",
            "args": null,
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "__Viewer_filters_connection",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v31/*: any*/),
                      (v10/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stage",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v10/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      {
                        "condition": "loadCustomFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "opportunityListCustomFields",
                            "args": (v12/*: any*/),
                            "concreteType": "CustomFieldValueV2TypeConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomFieldValueV2TypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v26/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "customFields(first:1000,list:\"OPPORTUNITY_LIST\")"
                          }
                        ]
                      },
                      (v74/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeRestricted:true,first:1000000)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompanyViewOpportunities_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              {
                "condition": "loadCustomFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "opportunityListCustomFieldDefinitions",
                    "args": (v12/*: any*/),
                    "concreteType": "CustomFieldDefinitionV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFieldDefinitionsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDefinitionV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/),
                              (v4/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "customFieldDefinitionsV2(first:1000,list:\"OPPORTUNITY_LIST\")"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v76/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": "filters(filterSection:\"OPPORTUNITIES\",first:1000000)"
          },
          {
            "alias": null,
            "args": (v76/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v31/*: any*/),
                      (v10/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stage",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v4/*: any*/),
                          (v10/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      {
                        "condition": "loadCustomFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "opportunityListCustomFields",
                            "args": (v12/*: any*/),
                            "concreteType": "CustomFieldValueV2TypeConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomFieldValueV2TypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v13/*: any*/),
                                      (v26/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "customFields(first:1000,list:\"OPPORTUNITY_LIST\")"
                          }
                        ]
                      },
                      (v74/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeRestricted:true,first:1000000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3413c279baaadcdc76b6a71abde5955f",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "viewer",
            "filters"
          ]
        }
      ]
    },
    "name": "CompanyViewOpportunities_Query",
    "operationKind": "query",
    "text": "query CompanyViewOpportunities_Query(\n  $clientId: String\n  $loadSingleCurrency: Boolean!\n  $loadMultiCurrency: Boolean!\n  $loadCustomFields: Boolean!\n) {\n  viewer {\n    id\n    actualPersonId\n    language\n    company {\n      id\n      currency\n      skillLevelsEnabled\n      opportunityStageBands(first: 1000) {\n        edges {\n          node {\n            id\n            name\n            startPercentage\n            endPercentage\n            winProbability\n          }\n        }\n      }\n      opportunityListCustomFieldDefinitions: customFieldDefinitionsV2(first: 1000, list: OPPORTUNITY_LIST) @include(if: $loadCustomFields) {\n        edges {\n          node {\n            __typename\n            id\n            key\n            displayName\n            type\n            ... on TextCustomField {\n              readOnly\n            }\n            ... on IntegerCustomField {\n              readOnly\n            }\n            ... on DecimalCustomField {\n              readOnly\n            }\n            ... on DateCustomField {\n              readOnly\n            }\n            ... on DropdownCustomField {\n              options {\n                id\n                displayName\n              }\n            }\n          }\n        }\n      }\n      client(id: $clientId) {\n        id\n        name\n        logoId\n        status {\n          label\n          standing\n          id\n        }\n      }\n    }\n    filters(first: 1000000, filterSection: OPPORTUNITIES) {\n      edges {\n        node {\n          id\n          name\n          value\n          section\n          updatedAt\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    projects(first: 1000000, excludeRestricted: true) {\n      edges {\n        node {\n          id\n          customProjectId\n          name\n          budgetType\n          stage {\n            __typename\n            id\n            name\n            profile\n          }\n          description\n          statusColor\n          companyProjectId\n          readOnlyAccess\n          budget\n          budgetBaseCurrency\n          projectColor\n          estimationUnit\n          minutesPerEstimationPoint\n          projectStartDay\n          projectStartMonth\n          projectStartYear\n          projectEndDay\n          projectEndMonth\n          projectEndYear\n          baselineWinChance\n          sprintTimeBox\n          currentProjectStatus {\n            id\n            color\n            person {\n              id\n              firstName\n              lastName\n            }\n          }\n          client {\n            id\n            name\n            logoId\n            logoDefaultId\n          }\n          rateCard {\n            id\n            name\n            currency\n            parentRateCardId\n          }\n          progress\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          priorityLevel {\n            id\n            name\n            weight\n          }\n          projectLabels(first: 10000) {\n            edges {\n              node {\n                id\n                label {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n          }\n          projectPersons(first: 1000000, contactsOnly: true) {\n            edges {\n              node {\n                id\n                isContactPerson\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  initials\n                }\n              }\n            }\n          }\n          wasOpportunity\n          useBaseline\n          baselineTarget\n          quote {\n            id\n            status\n            expiryDate\n          }\n          clientContact {\n            id\n            firstName\n            lastName\n            email\n          }\n          salesperson {\n            id\n            firstName\n            lastName\n            initials\n            profilePictureId\n          }\n          opportunityListCustomFields: customFields(first: 1000, list: OPPORTUNITY_LIST) @include(if: $loadCustomFields) {\n            edges {\n              node {\n                __typename\n                key\n                value\n                id\n              }\n            }\n          }\n          financialNumbers @include(if: $loadMultiCurrency) {\n            baselineRevenue\n            billablePlannedTimeAndExpenses\n            actualRevenue\n            remainingRevenue\n            forecastRevenue\n            recognitionOpenRevenue\n            recognitionForecastRevenue\n            recognitionLockedRevenue\n            plannedCost\n            actualCost\n            forecastCost\n            remainingCost\n            plannedProfit\n            forecastProfit\n            invoiced\n            paid\n          }\n          financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {\n            baselineRevenue\n            billablePlannedTimeAndExpenses\n            actualRevenue\n            remainingRevenue\n            forecastRevenue\n            recognitionOpenRevenue\n            recognitionForecastRevenue\n            recognitionLockedRevenue\n            plannedCost\n            actualCost\n            forecastCost\n            remainingCost\n            plannedProfit\n            forecastProfit\n            invoiced\n            paid\n          }\n          financialNumbers @include(if: $loadSingleCurrency) {\n            baselineRevenue\n            billablePlannedTimeAndExpenses\n            actualRevenue\n            remainingRevenue\n            forecastRevenue\n            recognitionOpenRevenue\n            recognitionForecastRevenue\n            recognitionLockedRevenue\n            plannedCost\n            actualCost\n            forecastCost\n            remainingCost\n            plannedProfit\n            forecastProfit\n            invoiced\n            paid\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acfb2a6e88715f2498c7406e7143dad2";

export default node;
